import React, { useState, useRef, useEffect } from "react";
import help_icon from "../images/sidebar_icon/help_icon.svg";
import calendar_month from "../images/sidebar_icon/calendar_month.svg";
import "../styles/nominee.css"; // Import styles
import DatePickerWithIcon from "../components/DatePickerWithIcon";
import SelectDropDown from "../components/SelectDropDown";
import DatePickerInput from "../components/DatePickerInput";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageUserData } from "../utils/userData";
import {
  userOnboardingGetDetails,
  userOnboardingStoreData,
  pincode,
  userNomineeDetail,
} from "../actions/usersActions";
import { toast } from "react-toastify";
import { convertDateToDDMMMYYYY } from "../utils/DateFormate";
import "../styles/profile.css";

const getOrdinalSuffix = (index) => {
  const j = index % 10,
    k = index % 100;

  if (j === 1 && k !== 11) return `${index}st`;
  if (j === 2 && k !== 12) return `${index}nd`;
  if (j === 3 && k !== 13) return `${index}rd`;
  return `${index}th`;
};

// Functional component for the Home page
const ManageNominees = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getLocalStorageUserData();
  const [noNominee, setNoNominee] = useState("N");
  const [soaNominee, setSoaNominee] = useState("N");
  const dateInputRef = useRef(null);
  const { userOnboardGetData,userNomineeDet, userOnboardStoreData, loading, error } =
    useSelector((state) => state.users);
  const formData = new FormData();
  // State to manage the nominees list
  const [nominees, setNominees] = useState([
    { name: "", relation: "", dob: "", percent: "", pan: "" },
  ]);
  const [nomineeCount, setNomineeCount] = useState(1);

  //   const handleSubmit = () => {
  //    window.location.href = "/dashboard";
  //   };

    useEffect(() => {
      dispatch(userNomineeDetail());
    }, []);

  const handleBack = () => {
    window.location.href = "/fatca-declartion";
  };
  useEffect(() => {
    const payload = {
      id: userData?.id,
      completed_wizard_step: 3,
    };
    dispatch(userOnboardingGetDetails(payload));
  }, []);

  // Function to handle input change for nominee fields
  //   const handleInputChange = (index, field, value) => {
  //     const updatedNominees = [...nominees];
  //     updatedNominees[index][field] = value;
  //     setNominees(updatedNominees);
  //   };

  useEffect(() => {
    if (userOnboardGetData?.data?.user_profile?.nominee_soa) {
      setSoaNominee(userOnboardGetData?.data?.user_profile?.nominee_soa);
    }
    setNoNominee(userOnboardGetData?.data?.user_profile?.no_of_nominees == 0 ? "Y" : "N")
    
  }, [userOnboardGetData]);

  const formik = useFormik({
    initialValues: {
      nominee_1_name:
        userOnboardGetData?.data?.user_profile?.nominee_1_name || "",
      nominee_1_relationship:
        userOnboardGetData?.data?.user_profile?.nominee_1_relationship || "",
      nominee_1_dob:
        userOnboardGetData?.data?.user_profile?.nominee_1_dob != null
          ? userOnboardGetData?.data?.user_profile?.nominee_1_dob
          : "" || "",
      nominee_1_applicable: userOnboardGetData?.data?.user_profile?.nominee_1_applicable ?
        parseFloat(
          userOnboardGetData?.data?.user_profile?.nominee_1_applicable
        ).toFixed(2) || "" : "",
      // nominee_1_pan: userOnboardGetData?.data?.user_profile?.nominee_1_pan || "",
      nominee_1_guardian:
        userOnboardGetData?.data?.user_profile?.nominee_1_guardian || "",
      nominee_1_guardian_pan:
        userOnboardGetData?.data?.user_profile?.nominee_1_guardian_pan || "",
      // New fields
      nominee_1_identity_type:
        userOnboardGetData?.data?.user_profile?.nominee_1_identity_type || "1",
      nominee_1_identity_number:
        userOnboardGetData?.data?.user_profile?.nominee_1_identity_number || "",
      nominee_1_email:
        userOnboardGetData?.data?.user_profile?.nominee_1_email || "",
      nominee_1_mobile:
        userOnboardGetData?.data?.user_profile?.nominee_1_mobile || "",
      nominee_1_address1:
        userOnboardGetData?.data?.user_profile?.nominee_1_address1
          ?.replace(/\s+/g, " ")
          .trim() || "",
      nominee_1_address2:
        userOnboardGetData?.data?.user_profile?.nominee_1_address2
          ?.replace(/\s+/g, " ")
          .trim() || "",
      nominee_1_city:
        userOnboardGetData?.data?.user_profile?.nominee_1_city || "",
      nominee_1_pin:
        userOnboardGetData?.data?.user_profile?.nominee_1_pin || "",
      // nominee_1_state:
      //   userOnboardGetData?.data?.user_profile?.nominee_1_state || "",
      nominee_1_country:
        userOnboardGetData?.data?.user_profile?.nominee_1_country || "",

      nominee_2_name:
        userOnboardGetData?.data?.user_profile?.nominee_2_name || "",
      nominee_2_relationship:
        userOnboardGetData?.data?.user_profile?.nominee_2_relationship || "",
      // ...(userOnboardGetData?.data?.user_profile?.nominee_2_pan
      //   ? { nominee_2_pan: userOnboardGetData?.data?.user_profile?.nominee_2_pan }
      //   : {}),
      nominee_2_dob:
        userOnboardGetData?.data?.user_profile?.nominee_2_dob != null
          ? userOnboardGetData?.data?.user_profile?.nominee_2_dob
          : "" || "",
      nominee_2_applicable: userOnboardGetData?.data?.user_profile
        ?.nominee_2_applicable
        ? parseFloat(
            userOnboardGetData?.data?.user_profile?.nominee_2_applicable
          ).toFixed(2)
        : 0 || "",
      nominee_2_guardian:
        userOnboardGetData?.data?.user_profile?.nominee_2_guardian || "",
      nominee_2_guardian_pan:
        userOnboardGetData?.data?.user_profile?.nominee_2_guardian_pan || "",
      //
      nominee_2_identity_type:
        userOnboardGetData?.data?.user_profile?.nominee_2_identity_type || "1",
      nominee_2_identity_number:
        userOnboardGetData?.data?.user_profile?.nominee_2_identity_number || "",
      nominee_2_email:
        userOnboardGetData?.data?.user_profile?.nominee_2_email || "",
      nominee_2_mobile:
        userOnboardGetData?.data?.user_profile?.nominee_2_mobile || "",
      nominee_2_address1:
        userOnboardGetData?.data?.user_profile?.nominee_2_address1
          ?.replace(/\s+/g, " ")
          .trim() || "",
      nominee_2_address2:
        userOnboardGetData?.data?.user_profile?.nominee_2_address2
          ?.replace(/\s+/g, " ")
          .trim() || "",
      nominee_2_city:
        userOnboardGetData?.data?.user_profile?.nominee_2_city || "",
      nominee_2_pin:
        userOnboardGetData?.data?.user_profile?.nominee_2_pin || "",
      // nominee_2_state:
      //   userOnboardGetData?.data?.user_profile?.nominee_2_state || "",
      nominee_2_country:
        userOnboardGetData?.data?.user_profile?.nominee_2_country || "",

      nominee_3_name:
        userOnboardGetData?.data?.user_profile?.nominee_3_name || "",
      nominee_3_relationship:
        userOnboardGetData?.data?.user_profile?.nominee_3_relationship || "",
      nominee_3_dob:
        userOnboardGetData?.data?.user_profile?.nominee_3_dob != null
          ? userOnboardGetData?.data?.user_profile?.nominee_3_dob
          : "" || "",
      // ...(userOnboardGetData?.data?.user_profile?.nominee_3_pan
      //   ? { nominee_3_pan: userOnboardGetData?.data?.user_profile?.nominee_3_pan }
      //   : {}),
      nominee_3_applicable: userOnboardGetData?.data?.user_profile
        ?.nominee_3_applicable
        ? parseFloat(
            userOnboardGetData?.data?.user_profile?.nominee_3_applicable
          ).toFixed(2)
        : 0 || "",
      nominee_3_guardian:
        userOnboardGetData?.data?.user_profile?.nominee_3_guardian || "",
      nominee_3_guardian_pan:
        userOnboardGetData?.data?.user_profile?.nominee_3_guardian_pan || "",
      // nominee_1_guardian_relationship:
      //   userOnboardGetData?.data?.user_profile?.nominee_1_guardian_relationship || "",
      // nominee_2_guardian_relationship:
      //   userOnboardGetData?.data?.user_profile?.nominee_2_guardian_relationship || "",
      // nominee_3_guardian_relationship:
      //   userOnboardGetData?.data?.user_profile?.nominee_3_guardian_relationship || "",
      // New Fields
      nominee_3_identity_type:
        userOnboardGetData?.data?.user_profile?.nominee_3_identity_type || "1",
      nominee_3_identity_number:
        userOnboardGetData?.data?.user_profile?.nominee_3_identity_number || "",
      nominee_3_email:
        userOnboardGetData?.data?.user_profile?.nominee_3_email || "",
      nominee_3_mobile:
        userOnboardGetData?.data?.user_profile?.nominee_3_mobile || "",
      nominee_3_address1:
        userOnboardGetData?.data?.user_profile?.nominee_3_address1
          ?.replace(/\s+/g, " ")
          .trim() || "",
      nominee_3_address2:
        userOnboardGetData?.data?.user_profile?.nominee_3_address2
          ?.replace(/\s+/g, " ")
          .trim() || "",
      nominee_3_city:
        userOnboardGetData?.data?.user_profile?.nominee_3_city || "",
      nominee_3_pin:
        userOnboardGetData?.data?.user_profile?.nominee_3_pin || "",
      // nominee_3_state:
      //   userOnboardGetData?.data?.user_profile?.nominee_3_state || "",
      nominee_3_country:
        userOnboardGetData?.data?.user_profile?.nominee_3_country || "",

      nominee_soa: userOnboardGetData?.data?.user_profile?.nominee_soa || "N",
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors = {};

      for (let i = 1; i <= nomineeCount; i++) {
        const nameKey = `nominee_${i}_name`;
        const relationKey = `nominee_${i}_relationship`;
        const dobKey = `nominee_${i}_dob`;
        const percentKey = `nominee_${i}_applicable`;
        const guardianNameKey = `nominee_${i}_guardian`;
        // const guardianRelationKey = `nominee_${i}_guardian_relationship`;
        const guardianPanKey = `nominee_${i}_guardian_pan`;
        const panKey = `nominee_${i}_pan`;

        // // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
        const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
        const pincodeKey = `${prefix}_pin`;
        const cityKey = `${prefix}_city`;
        // const stateKey = `${prefix}_state`;

        const idTypeKey = `nominee_${i}_identity_type`;
        const idNumberKey = `nominee_${i}_identity_number`;
        const emailKey = `nominee_${i}_email`;
        const mobileKey = `nominee_${i}_mobile`;
        // Special case for address keys
        const address1Key =
          i === 1 ? `nominee_${i}_address1` : `nominee_${i}_address1`;

        const currentDate = new Date();
        const dob = new Date(values[dobKey]);
        const age = currentDate.getFullYear() - dob.getFullYear();
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
        const mobileRegex = /^[6-9]\d{9}$/;

        
         if (!values[nameKey] || values[nameKey].trim() === "") {
  errors[nameKey] = "Name is required";
} else if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(values[nameKey].trim())) {
  errors[nameKey] = "Name must contain only alphabets";
}

        // if (age >= 18) {
        //   if (!values[panKey]) {
        //     errors[panKey] = "PAN Number is required";
        //   } else if (!panRegex.test(values[panKey])) {
        //     errors[panKey] = "Invalid PAN format (e.g., ABCDE1234F)";
        //   }
        // }
        if (!values[relationKey] || values[relationKey] === "Select")
          errors[relationKey] = "Relation is required";
        if (!values[dobKey]) errors[dobKey] = "Date of birth is required";
        if (
          !values[percentKey] ||
          values[percentKey] <= 0 ||
          values[percentKey] > 100
        ) {
          errors[percentKey] = "Percentage must be between 1 and 100";
        }

        if (age < 18) {
          if (!values[guardianNameKey]) {
            errors[guardianNameKey] = "Guardian Name is required";
          } else if (!/^[A-Za-z\s]+$/.test(values[guardianNameKey])) {
            errors[guardianNameKey] =
              "Guardian Name must contain only alphabets";
          }

          // if (
          //   !values[guardianRelationKey] ||
          //   values[guardianRelationKey] === "Select"
          // )
          //   errors[guardianRelationKey] = "Guardian Relation is required";

          if (!values[guardianPanKey]) {
            errors[guardianPanKey] = "Guardian PAN is required";
          } else if (!panRegex.test(values[guardianPanKey])) {
            errors[guardianPanKey] = "Invalid PAN format (e.g., ABCDE1234F)";
          }
        }
        // Additional Field Validations
        // ID Type
        if (age > 18) {
          // if (!values[idTypeKey]) {
          //   errors[idTypeKey] = "Nominee ID Type is required";
          // }

          if (!values[idNumberKey]) {
            errors[idNumberKey] = "Nominee ID Number is required";
          } else {
            const idType = values[idTypeKey] || "1";
            const idNumber = values[idNumberKey];

            switch (idType) {
              case "1":
                if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(idNumber)) {
                  errors[idNumberKey] = "Invalid PAN format (e.g., ABCDE1234F)";
                }
                break;

              case "2":
                if (!/^\d{4}$/.test(idNumber)) {
                  errors[idNumberKey] = "Enter last 4 digits of Aadhaar";
                }
                break;

              case "3": // Driving Licence
                if (!/^[A-Z]{2}\d{2}\s?\d{11}$/.test(idNumber)) {
                  errors[idNumberKey] =
                    "Invalid Driving Licence format (e.g., MH12 12345678901)";
                }
                break;

              case "4": // Passport
                if (!/^[A-PR-WY][0-9]{7}$/.test(idNumber)) {
                  errors[idNumberKey] =
                    "Invalid Passport format (e.g., A1234567)";
                }
                break;

              default:
                errors[idNumberKey] = "Invalid ID Type selected";
                break;
            }
          }
        }

        // Email (simple)
        if (!values[emailKey]) {
          errors[emailKey] = "Nominee Email is required";
        } else if (
          !values[emailKey].includes("@") ||
          !values[emailKey].includes(".")
        ) {
          errors[emailKey] = "Enter a valid email address";
        }

        // // Mobile (simple)
        if (!values[mobileKey]) {
          errors[mobileKey] = "Nominee Mobile Number is required";
        } else if (!mobileRegex.test(values[mobileKey])) {
          errors[mobileKey] = "Mobile number must be 10 digits";
        }

        // Address1
        if (!values[address1Key]) {
          errors[address1Key] = "Nominee Address is required";
        } else if (values[address1Key].length > 40) {
          errors[address1Key] = "Max 40 characters";
        }

        if (!values[pincodeKey]) {
          errors[pincodeKey] = "Nominee Pincode is required";
        } else if (
          String(values[pincodeKey]).length !== 6 ||
          isNaN(values[pincodeKey])
        ) {
          errors[pincodeKey] = "Pincode must be 6 digits";
        }

        // City
        if (!values[cityKey]) {
          errors[cityKey] = "Nominee City is required";
        }

        // State
        // if (!values[stateKey] || values[stateKey] === "Select") {
        //   errors[stateKey] = "Nominee State is required";
        // }
      }

      return errors;
    },
    onSubmit: (values) => {
      const formatDate = (dateString) => {
        const date = new Date(dateString);

        const options = {
          day: "2-digit",
          month: "short", // 'short' gives abbreviated month names like 'Jan', 'Feb', etc.
          year: "numeric",
        };

        return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
      };

      const payload = {
        ...values,
        nominee_1_dob: values?.nominee_1_dob
          ? convertDateToDDMMMYYYY(values?.nominee_1_dob)
          : "",
        nominee_2_dob: values?.nominee_2_dob
          ? convertDateToDDMMMYYYY(values?.nominee_2_dob)
          : "",
        nominee_3_dob: values?.nominee_3_dob
          ? convertDateToDDMMMYYYY(values?.nominee_3_dob)
          : "",
        completed_wizard_step: 3,
      };

      const nom1 = values?.nominee_1_applicable
        ? parseFloat(values?.nominee_1_applicable)
        : 0;
      const nom2 = values?.nominee_2_applicable
        ? parseFloat(values?.nominee_2_applicable)
        : 0;
      const nom3 = values?.nominee_3_applicable
        ? parseFloat(values?.nominee_3_applicable)
        : 0;

      for (const key in payload) {
        formData.append(key, payload[key]);
      }

      console.log("noNominee", noNominee)
      if (noNominee == "Y") {
        const noNomineePayload = {
          completed_wizard_step: 3,
          noNominee: "Y",
          no_of_nominees: nomineeCount,
        };
        dispatch(
          userOnboardingStoreData(noNomineePayload, userData?.id, 3)
        ).then((response) => {
          if (response.data.success == true) {
            if (response.data.wizard_step == 1) {
             window.location.href = "/bank-details";
            } else if (response.data.wizard_step == 2) {
              window.location.href =   "/fatca-declartion"
            } else if (response.data.wizard_step == 3) {
              window.location.href =  "/manage-nominees"
            } else if (response.data.wizard_step == 4) {
              window.location.href =  "/dashboard"
            } else if (response.wizard_step == null) {
              window.location.href =  "/dashboard"
            }
          }
        });
      } else {
        if (nom1 + nom2 + nom3 == 100) {
          formData.append("no_of_nominees", nomineeCount);
          dispatch(userOnboardingStoreData(formData, 0, 3)).then((response) => {
            if (response?.data?.success == true) {
              if (response.data.wizard_step == 1) {
                window.location.href =  "/bank-details"
              } else if (response.data.wizard_step == 2) {
                window.location.href =  "/fatca-declartion"
              } else if (response.data.wizard_step == 3) {
                window.location.href =  "/manage-nominees"
              } else if (response.data.wizard_step == 4) {
                window.location.href =  "/dashboard"
              } else if (response.wizard_step == null) {
                window.location.href =  "/dashboard"
              }
            }
          });
        } else {
          toast.error("Total percentage cannot exceed 100%");
        }
      }
    },
  });

  useEffect(() => {
    setNomineeCount(
      userOnboardGetData?.data?.user_profile?.no_of_nominees == null
        ? 1
        : userOnboardGetData?.data?.user_profile?.no_of_nominees
    );
  }, [userOnboardGetData]);

  // Function to add a new nominee form (up to 3 nominees)
  const addNominee = () => {
    if (nomineeCount != 3) {
      //   setNominees([
      //     ...nominees,
      //     { name: "", relation: "", dob: "", percent: "", pan: "" },
      //   ]);
      setNomineeCount(nomineeCount + 1);
      setNoNominee("N");
      const prefix =
        nomineeCount === 1
          ? `nominee_${nomineeCount + 1}`
          : `nominee_${nomineeCount + 1}`;
      // Special case for address keys
      const address1Key =
        nomineeCount === 1
          ? `nominee_${nomineeCount + 1}_address1`
          : `nominee_${nomineeCount + 1}_address1`;

      formik.setValues({
        ...values,
        [`nominee_${nomineeCount + 1}_name`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_name`
          ] || "",
        [`nominee_${nomineeCount + 1}_relationship`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_relationship`
          ] || "",
        [`nominee_${nomineeCount + 1}_dob`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_dob`
          ] != null
            ? userOnboardGetData?.data?.user_profile?.[
                `nominee_${nomineeCount + 1}_dob`
              ]
            : "" || "",
        [`nominee_${nomineeCount + 1}_applicable`]: userOnboardGetData?.data
          ?.user_profile?.[`nominee_${nomineeCount + 1}_applicable`]
          ? parseFloat(
              userOnboardGetData?.data?.user_profile?.[
                `nominee_${nomineeCount + 1}_applicable`
              ]
            ).toFixed(2)
          : "" || "",
        [`nominee_${nomineeCount + 1}_guardian`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_guardian`
          ] || "",
        [`nominee_${nomineeCount + 1}_guardian_pan`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_guardian_pan`
          ] || "",
        // [`nominee_${nomineeCount + 1}_guardian_relationship`]:
        //   userOnboardGetData?.data?.user_profile?.[
        //     `nominee_${nomineeCount + 1}_guardian_relationship`
        //   ] || "",
        [`nominee_${nomineeCount + 1}_identity_type`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_identity_type`
          ] || "1",
        [`nominee_${nomineeCount + 1}_identity_number`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_identity_number`
          ] || "",
        [`nominee_${nomineeCount + 1}_email`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_email`
          ] || "",
        [`nominee_${nomineeCount + 1}_mobile`]:
          userOnboardGetData?.data?.user_profile?.[
            `nominee_${nomineeCount + 1}_mobile`
          ] || "",
        [`${address1Key}`]:
          userOnboardGetData?.data?.user_profile?.[`${address1Key}`] || "",
        [`${prefix}_pin`]:
          userOnboardGetData?.data?.user_profile?.[`${prefix}_pin`] || "",
        [`${prefix}_city`]:
          userOnboardGetData?.data?.user_profile?.[`${prefix}_city`] || "",
        // [`${prefix}_state`]:
        //   userOnboardGetData?.data?.user_profile?.[`${prefix}_state`] || "",
      });
    }
  };

      const parseDate = (input) => {
        console.log("input11111", input, input == "Invalid Date")
  if (!input || input == "Invalid Date") return null;

  // Check if input is ISO format
  if (input?.includes("T")) {
    const date = new Date(input);
    return isNaN(date.getTime()) ? null : date;
  }

  // Assume format is DD-MM-YYYY
  const [day, month, year] = input.split("-").map(Number);
  if (!day || !month || !year) return null;

  return new Date(year, month - 1, day); // month is 0-indexed
};

const calculateAge = (dob) => {
  if(!dob || dob == "Invalid Date") return null;

  const birthDate = parseDate(dob);
  if (!birthDate) return null;

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};


  const handleIconClick = () => {
    if (dateInputRef.current) {
      if (dateInputRef.current.showPicker) {
        dateInputRef.current.showPicker(); // For modern browsers
      } else {
        dateInputRef.current.focus(); // Fallback for older browsers
      }
    }
  };

  // const deleteNominee = (position) => {
  //   const updatedValues = { ...formik.values };

  //   // Remove the specific nominee
  //   for (let i = position; i < nomineeCount; i++) {
  //     updatedValues[`nominee_${i}_name`] =
  //       updatedValues[`nominee_${i + 1}_name`] || "";
  //     updatedValues[`nominee_${i}_relationship`] =
  //       updatedValues[`nominee_${i + 1}_relationship`] || "";
  //     updatedValues[`nominee_${i}_dob`] =
  //       updatedValues[`nominee_${i + 1}_dob`] || "";
  //     updatedValues[`nominee_${i}_applicable`] =
  //       updatedValues[`nominee_${i + 1}_applicable`] || "";
  //     updatedValues[`nominee_${i}_guardian`] =
  //       updatedValues[`nominee_${i + 1}_guardian`] || "";
  //     updatedValues[`nominee_${i}_guardian_pan`] =
  //       updatedValues[`nominee_${i + 1}_guardian_pan`] || "";
  //   }

  //   // Remove the last nominee (shifted forward)
  //   delete updatedValues[`nominee_${nomineeCount}_name`];
  //   delete updatedValues[`nominee_${nomineeCount}_relationship`];
  //   delete updatedValues[`nominee_${nomineeCount}_dob`];
  //   delete updatedValues[`nominee_${nomineeCount}_applicable`];
  //   delete updatedValues[`nominee_${nomineeCount}_guardian`];
  //   delete updatedValues[`nominee_${nomineeCount}_guardian_pan`];

  //   setNomineeCount(nomineeCount - 1);
  //   formik.setValues(updatedValues);
  // };
  const deleteNominee = (position) => {
    const updatedValues = { ...formik.values };

    for (let i = position; i < nomineeCount; i++) {
      const from = i + 1;
      const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
      const fromPrefix = from === 1 ? `nominee_${from}` : `nominee_${from}`;

      const address1Key =
        i === 1 ? `nominee_${i}_address1` : `nominee_${i}_address1`;
      const fromAddress1Key =
        from === 1 ? `nominee_${from}_address1` : `nominee_${from}_address1`;

      const address2Key =
        i === 1 ? `nominee_${i}_address2` : `nominee_${i}_address2`;
      const fromAddress2Key =
        from === 1 ? `nominee_${from}_address2` : `nominee_${from}_address2`;

      // Shift values up from next nominee
      updatedValues[`nominee_${i}_name`] =
        updatedValues[`nominee_${from}_name`] || "";
      updatedValues[`nominee_${i}_relationship`] =
        updatedValues[`nominee_${from}_relationship`] || "";
      updatedValues[`nominee_${i}_dob`] =
        updatedValues[`nominee_${from}_dob`] || "";
      // updatedValues[`nominee_${i}_pan`] = updatedValues[`nominee_${from}_pan`] || "";
      updatedValues[`nominee_${i}_applicable`] =
        updatedValues[`nominee_${from}_applicable`] || "";
      updatedValues[`nominee_${i}_guardian`] =
        updatedValues[`nominee_${from}_guardian`] || "";
      updatedValues[`nominee_${i}_guardian_pan`] =
        updatedValues[`nominee_${from}_guardian_pan`] || "";
      // updatedValues[`nominee_${i}_guardian_relationship`] =
      //   updatedValues[`nominee_${from}_guardian_relationship`] || "";

      updatedValues[`nominee_${i}_identity_type`] =
        updatedValues[`nominee_${from}_identity_type`] || "";
      updatedValues[`nominee_${i}_identity_number`] =
        updatedValues[`nominee_${from}_identity_number`] || "";
      updatedValues[`nominee_${i}_email`] =
        updatedValues[`nominee_${from}_email`] || "";
      updatedValues[`nominee_${i}_mobile`] =
        updatedValues[`nominee_${from}_mobile`] || "";

      updatedValues[`${prefix}_pin`] = updatedValues[`${fromPrefix}_pin`] || "";
      updatedValues[`${prefix}_city`] =
        updatedValues[`${fromPrefix}_city`] || "";
      // updatedValues[`${prefix}_state`] =
      //   updatedValues[`${fromPrefix}_state`] || "";
      updatedValues[`${prefix}_country`] =
        updatedValues[`${fromPrefix}_country`] || "";
      updatedValues[address1Key] = updatedValues[fromAddress1Key] || "";
      updatedValues[address2Key] = updatedValues[fromAddress2Key] || "";
    }

    // Clean up last nominee data
    const last = nomineeCount;
    const lastPrefix = last === 1 ? `nominee_${last}` : `nominee_${last}`;
    updatedValues[`nominee_${last}_name`] = "";
    updatedValues[`nominee_${last}_relationship`] = "";
    updatedValues[`nominee_${last}_dob`] = "";
    // updatedValues[`nominee_${last}_pan`] = "";
    updatedValues[`nominee_${last}_applicable`] = "";
    updatedValues[`nominee_${last}_guardian`] = "";
    updatedValues[`nominee_${last}_guardian_pan`] = "";
    // updatedValues[`nominee_${last}_guardian_relationship`] = "";
    updatedValues[`nominee_${last}_identity_type`] = "";
    updatedValues[`nominee_${last}_identity_number`] = "";
    updatedValues[`nominee_${last}_email`] = "";
    updatedValues[`nominee_${last}_mobile`] = "";
    updatedValues[`${lastPrefix}_pin`] = "";
    updatedValues[`${lastPrefix}_city`] = "";
    // updatedValues[`${lastPrefix}_state`] = "";
    updatedValues[`${lastPrefix}_country`] = "";
    updatedValues[
      last === 1 ? `nominee_${last}_address1` : `nominee_${last}_address1`
    ] = "";
    updatedValues[
      last === 1 ? `nominee_${last}_address2` : `nominee_${last}_address2`
    ] = "";
    setNomineeCount(nomineeCount - 1);
    formik.setValues(updatedValues);
  };
  const { values, errors, handleChange, setFieldValue, handleSubmit } = formik;
  useEffect(() => {
    if (userOnboardGetData) {
      if (
       (userOnboardGetData?.wizard_step == 4 ||
        userOnboardGetData?.wizard_step == 5) && userOnboardGetData?.is_wizard_completed == true
      ) {
       window.location.href = "/dashboard";
      } else if (3 <= userOnboardGetData?.wizard_step) {
      } else {
        if (userOnboardGetData?.wizard_step == 0) {
         window.location.href = "/personal-details";
        } else if (userOnboardGetData?.wizard_step == 1) {
         window.location.href = "/bank-details";
        } else if (userOnboardGetData?.wizard_step == 2) {
         window.location.href = "/fatca-declartion";
        }
      }
    }
  }, [userOnboardGetData]);

  const nomineeTypeOptions = [
    { value: "1", label: "PAN" },
    { value: "2", label: "Aadhar" },
    { value: "3", label: "Driving Licence" },
    { value: "4", label: "Passport" },
  ];

  const callStateAndDistrict = async (pin, cityKey, countryKey) => {
    try {
      if (pin?.length === 6) {
        const payload = { pincode: pin };
        dispatch(pincode(payload))
          .then((res) => {
            formik?.setFieldValue(cityKey, res?.data?.data?.city? res?.data?.data?.city : "");
            // formik?.setFieldValue(stateKey, res?.data?.data?.state_code || "");
            formik?.setFieldValue(
              countryKey,
              res?.data?.data?.country_code || ""
            );
          })
          .catch((error) => {
            console.log("Error fetching city/state:", error);
          });
      }
    } catch (error) {
      console.error("Error in pincode lookup:", error);
    }
  };

  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="progress-container page_inner_content_box">
          <div className="step-info">
            <span>Step 4 of 4</span>
          </div>
          <h4 className="page-title mb-0">Manage Nominees</h4>
        </div>
        <div className="progress-bar">
          <div className="progress-filled" style={{ width: "100%" }}></div>
        </div>
        <div className="page_inner_content_box d-flex flex-wrap justify-content-between ">
          <form
            id="manage_nominee"
            className="step_form"
            onSubmit={handleSubmit}
          >
            <div className="card border-0">
              <div className="card-body form_card">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-12 order-lg-1 order-2">
                    <div className="form-check mb-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="no_nominee"
                        checked={noNominee == "Y"}
                        onChange={(e) => {
                          if (e.target.checked == true) {
                            setNomineeCount(0);
                            setNoNominee("Y");
                          } else {
                            setNomineeCount(1);
                            setNoNominee("N");
                          }
                        }}
                      />
                      <label className="form-check-label" for="no_nominee">
                        I do not wish to add nominee.
                      </label>
                    </div>
                    <div className="form-check mb-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="nominee_soa"
                        checked={soaNominee == "Y"}
                        onChange={(e) => {
                          setSoaNominee(e.target.checked ? "Y" : "N");
                          formik.setFieldValue(
                            "nominee_soa",
                            e.target.checked ? "Y" : "N"
                          );
                        }}
                      />
                      <label className="form-check-label" for="no_nominee">
                        SOA
                      </label>
                      <div className="tooltip-wrapper">
                        <span className="fa fa-info-circle info-icon"></span>
                        <div className="tooltip-content">
                          If the SOA is checked, only the nominee registration
                          status will be shown in the SOA.
                          <br />
                          If unchecked, the names of the registered nominee will
                          be displayed.
                        </div>
                      </div>
                    </div>
                    {[...Array(nomineeCount)].map((_, index) => {
                      const i = index + 1;
                      const nameKey = `nominee_${i}_name`;
                      const relationKey = `nominee_${i}_relationship`;
                      const dobKey = `nominee_${i}_dob`;
                      const percentKey = `nominee_${i}_applicable`;
                      const panKey = `nominee_${i}_pan`;
                      const guardianNameKey = `nominee_${i}_guardian`;
                      const guardianPanKey = `nominee_${i}_guardian_pan`;

                      // const guardianRelationKey = `nominee_${i}_guardian_relationship`;

                      // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
                      const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
                      const pincodeKey = `${prefix}_pin`;
                      const cityKey = `${prefix}_city`;
                      // const stateKey = `${prefix}_state`;

                      const idTypeKey = `nominee_${i}_identity_type`;
                      const idNumberKey = `nominee_${i}_identity_number`;
                      const emailKey = `nominee_${i}_email`;
                      const mobileKey = `nominee_${i}_mobile`;
                      const countryKey = `nominee_${i}_country`;

                      // Special case for address keys
                      const address1Key =
                        i === 1
                          ? `nominee_${i}_address1`
                          : `nominee_${i}_address1`;
                      const address2Key =
                        i === 1
                          ? `nominee_${i}_address2`
                          : `nominee_${i}_address2`;

                      const dob = values[dobKey];
                     const age = calculateAge(dob)

                        console.log("ageage", age)
                      return (
                        <div key={i}>
                          <div
                            className="mb-4"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <h5 className="nominee_title">
                              {`${getOrdinalSuffix(i)} Nominee:`}
                            </h5>
                            <button
                              type="button"
                              className="delete_button text-decoration-none"
                              onClick={deleteNominee}
                              style={{ marginBottom: "0px" }}
                            >
                              <span>-</span> Delete nominee
                            </button>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={nameKey} className="form-label">
                                Nominee Name*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={nameKey}
                                name={nameKey}
                                placeholder="Enter Nominee Name"
                                value={values[nameKey]}
                                onChange={handleChange}
                              />
                              {errors[nameKey] && (
                                <div className="text-danger">
                                  {errors[nameKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={relationKey}
                                className="form-label"
                              >
                                Relation*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                name={relationKey}
                                id={relationKey}
                                value={values[relationKey]}
                                changeFunction={(value) =>
                                  setFieldValue(relationKey, value)
                                }
                                options={userOnboardGetData?.data?.relations?.map(
                                  (relation) => ({
                                    value: relation.relationship_code,
                                    label: relation.relationship_name,
                                  })
                                )}
                              />
                              {errors[relationKey] && (
                                <div className="text-danger">
                                  {errors[relationKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={`dob-${index}`}
                                className="form-label"
                              >
                                Nominee Date of Birth*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <DatePickerInput
                                id={dobKey}
                                selectedDate={values[dobKey]}
                                maxDate={new Date().toISOString().split("T")[0]}
                                onChange={(date) => setFieldValue(dobKey, date)}
                                name={dobKey}
                              />
                              {errors[dobKey] && (
                                <div className="text-danger">
                                  {errors[dobKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={`percent-${index}`}
                                className="form-label"
                              >
                                Nominee %*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="number"
                                id={percentKey}
                                name={percentKey}
                                className="form-control"
                                placeholder="Enter Nominee %"
                                value={values[percentKey]}
                                onChange={handleChange}
                              />
                              {errors[percentKey] && (
                                <div className="text-danger">
                                  {errors[percentKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {(age >= 18 || age === null) && (
                            <>
                              {/* Nominee Type */}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={idTypeKey}
                                    className="form-label"
                                  >
                                    Nominee Identity Type *
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <SelectDropDown
                                    name={idTypeKey}
                                    id={idTypeKey}
                                    value={values[idTypeKey] || "1"}
                                    changeFunction={(value) =>
                                      setFieldValue(idTypeKey, value)
                                    }
                                    options={nomineeTypeOptions?.map(
                                      (state) => ({
                                        value: state.value,
                                        label: state.label,
                                      })
                                    )}
                                     disabled="true"
                                  />
                                  {errors[idTypeKey] && (
                                    <div className="text-danger">
                                      {errors[idTypeKey]}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Nominee Id Number */}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={idNumberKey}
                                    className="form-label"
                                  >
                                    Nominee ID number *
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={idNumberKey}
                                    name={idNumberKey}
                                    placeholder="Enter Id Number"
                                    value={values[idNumberKey] || ""}
                                    onChange={(e) => {
                                      const upper =
                                        e.target.value.toUpperCase();
                                      handleChange({
                                        target: {
                                          name: idNumberKey,
                                          value: upper,
                                        },
                                      });
                                    }}
                                  />
                                  {errors[idNumberKey] && (
                                    <div className="text-danger">
                                      {errors[idNumberKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Nominee Email */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={emailKey} className="form-label">
                                Nominee Email *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="email"
                                className="form-control"
                                id={emailKey}
                                name={emailKey}
                                placeholder="Enter Nominee Email"
                                value={values[emailKey] || ""}
                                  onChange={(e) => setFieldValue(emailKey, e.target.value.toLowerCase())}
                              />
                              {errors[emailKey] && (
                                <div className="text-danger">
                                  {errors[emailKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Mobile Number */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={mobileKey} className="form-label">
                                Nominee Mobile *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="number"
                                className="form-control"
                                id={mobileKey}
                                name={mobileKey}
                                placeholder="Enter Nominee Mobile"
                                value={values[mobileKey] || ""}
                                onChange={handleChange}
                              />
                              {errors[mobileKey] && (
                                <div className="text-danger">
                                  {errors[mobileKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Address */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={address1Key}
                                className="form-label"
                              >
                                Nominee Address 1 *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={address1Key}
                                name={address1Key}
                                placeholder="Enter Nominee Address 1"
                                value={values[address1Key] || ""}
                                onChange={handleChange}
                              />
                              {errors[address1Key] && (
                                <div className="text-danger">
                                  {errors[address1Key]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Address 2 */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={address2Key}
                                className="form-label"
                              >
                                Nominee Address 2
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={address2Key}
                                name={address2Key}
                                placeholder="Enter Nominee Address 2"
                                value={values[address2Key] || ""}
                                onChange={handleChange}
                              />
                              {errors[address2Key] && (
                                <div className="text-danger">
                                  {errors[address2Key]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Pin Code */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={pincodeKey}
                                className="form-label"
                              >
                                Nominee Pincode *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="number"
                                className="form-control"
                                id={pincodeKey}
                                name={pincodeKey}
                                placeholder="Enter Nominee Pincode"
                                value={values[pincodeKey] || ""}
                                onChange={(e) => {
                                  handleChange(e);
                                  callStateAndDistrict(
                                    e.target.value,
                                    cityKey,
                                    // stateKey,
                                    countryKey
                                  );
                                }}
                              />
                              {errors[pincodeKey] && (
                                <div className="text-danger">
                                  {errors[pincodeKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee City */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={cityKey} className="form-label">
                                Nominee City *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={cityKey}
                                name={cityKey}
                                placeholder="Enter Nominee City"
                                value={values[cityKey] || ""}
                                onChange={handleChange}
                              />
                              {errors[cityKey] && (
                                <div className="text-danger">
                                  {errors[cityKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee State */}
                          {/* <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={stateKey} className="form-label">
                                Nominee State *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                name={stateKey}
                                id={stateKey}
                                value={values[stateKey] || ""}
                                changeFunction={(value) =>
                                  setFieldValue(stateKey, value)
                                }
                                options={userOnboardGetData?.data?.states?.map(
                                  (state) => ({
                                    value: state.state_code,
                                    label: state.state_name,
                                  })
                                )}
                              />
                              {errors[stateKey] && (
                                <div className="text-danger">
                                  {errors[stateKey]}
                                </div>
                              )}
                            </div>
                          </div> */}

                          {/* Nominee Country */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={countryKey}
                                className="form-label"
                              >
                                Nominee Country *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                               <SelectDropDown
                            id={countryKey}
                            name={countryKey}
                            value={formik.values[countryKey] || ""}
                            changeFunction={(value) =>
                              formik.setFieldValue(countryKey, value)
                            }
                            options={userNomineeDet?.data?.countries?.map(
                              (state) => ({
                                value: state.country_name,
                                label: state.country_name,
                              })
                            )}
                          />
                              {errors[countryKey] && (
                                <div className="text-danger">
                                  {errors[countryKey]}
                                </div>
                              )}
                            </div>
                          </div>
                          {age >= 18 || age === null ? (
                            <></>
                          ) : (
                            // <div className="row align-items-center mb-4">
                            //   <div className="col-lg-5 col-md-6">
                            //     <label htmlFor={panKey} className="form-label">
                            //       Enter Pan Number*
                            //     </label>
                            //   </div>
                            //   <div className="col-lg-7 col-md-6">
                            //     <input
                            //       type="text"
                            //       className="form-control"
                            //       id={panKey}
                            //       name={panKey}
                            //       placeholder="Enter Pan Number"
                            //       value={values[panKey]}
                            //       onChange={handleChange}
                            //     />
                            //     {errors[panKey] && (
                            //       <div className="text-danger">
                            //         {errors[panKey]}
                            //       </div>
                            //     )}
                            //   </div>
                            // </div>
                            <>
                              {" "}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={`percent-${index}`}
                                    className="form-label"
                                  >
                                    Guardian Name*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    id={guardianNameKey}
                                    name={guardianNameKey}
                                    className="form-control"
                                    placeholder="Guardian Name"
                                    value={values[guardianNameKey]}
                                    onChange={handleChange}
                                  />
                                  {errors[guardianNameKey] && (
                                    <div className="text-danger">
                                      {errors[guardianNameKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={`percent-${index}`}
                                    className="form-label"
                                  >
                                    Guardian Pan*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    id={guardianPanKey}
                                    name={guardianPanKey}
                                    className="form-control"
                                    placeholder="Guardian Pan"
                                    value={values[guardianPanKey]}
                                    // onChange={handleChange}
                                    onChange={(e) => {
                                      const upperValue = e.target.value.toUpperCase();
                                      handleChange({
                                        target: {
                                          name: guardianPanKey,
                                          value: upperValue,
                                        },
                                      });
                                    }}
                                  />
                                  {errors[guardianPanKey] && (
                                    <div className="text-danger">
                                      {errors[guardianPanKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={guardianRelationKey}
                                    className="form-label"
                                  >
                                    Guardian Relation*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <SelectDropDown
                                    name={guardianRelationKey}
                                    id={guardianRelationKey}
                                    value={values[guardianRelationKey]}
                                    changeFunction={(value) =>
                                      setFieldValue(guardianRelationKey, value)
                                    }
                                    options={userOnboardGetData?.data?.relations?.map(
                                      (relation) => ({
                                        value: relation.value,
                                        label: relation.label,
                                      })
                                    )}
                                  />
                                  {errors[guardianRelationKey] && (
                                    <div className="text-danger">
                                      {errors[guardianRelationKey]}
                                    </div>
                                  )}
                                </div>
                              </div> */}
                            </>
                          )}
                        </div>
                      );
                    })}
                    {(nomineeCount > 0 && nomineeCount < 3) && (
                      <div className="text-start">
                        <button
                          type="button"
                          className="more_button text-decoration-none"
                          onClick={addNominee}
                        >
                          <span>+</span> Add More
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="col-xl-5 col-lg-4 ps-xl-5 order-lg-2 order-1 mb-lg-0 mb-4">
                    <div className="info-box px-lg-4">
                      <div className="d-flex align-items-start">
                        <img
                          src={help_icon}
                          alt=""
                          className="me-3"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <div>
                          <h5 className="fw-semibold mb-3">
                            Secure Your Legacy
                          </h5>
                          <p className="mb-2">
                            Designate nominees to ensure your investments are
                            transferred according to your wishes. This step
                            gives you peace of mind for the future.
                          </p>
                          <p className="highlight_text">
                            You can add a maximum of 3 Nominees.
                          </p>
                          <p className="highlight_text">
                            You can edit these details later if needed.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer form_card card_footer">
                <div className="d-flex justify-content-between gap-2">
                  <button
                    type="button"
                    className="form_button"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  <button
                    type="submit"
                    className="form_button next_btn"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ManageNominees;
